export const getTrendingSearchesPathForLocation = (slug: any) =>
    `/trending/searches/${slug}/`;
